import { nextTick } from 'vue';

const useFormInput = () => {
  const focusFirstErrInput = (id: string) => {
    nextTick(() => {
      const firstErrInput = document.querySelector(`#${id}`);

      if (firstErrInput) (firstErrInput as HTMLInputElement).focus();
    });
  };

  const focusElement = (id: string) => {
    nextTick(() => {
      const element = document.querySelector(`#${id}`);

      if (element) {
        (element as HTMLInputElement).focus();

        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  };

  const focusFirstErrInputV2 = async () => {
    await nextTick();

    const firstErrInput = document.querySelector(
      '.el-form-item.is-error input'
    );

    const firstTextareaInput = document.querySelector(
      '.el-form-item.is-error textarea'
    );

    if (firstErrInput) {
      (firstErrInput as HTMLInputElement).focus();

      firstErrInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (firstTextareaInput) {
      (firstTextareaInput as HTMLTextAreaElement).focus();

      firstTextareaInput.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  return {
    focusElement,
    focusFirstErrInput,
    focusFirstErrInputV2,
  };
};

export default useFormInput;
